<script setup lang="ts">
import type { DirectSaleListingItemEntity } from '~/apiClient';

// PROPS
interface Props {
    directSale: DirectSaleListingItemEntity;
}

const { directSale } = defineProps<Props>();

// COMPOSABLES
const { title } = useDirectSaleStatus(toRef(() => directSale));
</script>

<template>
    <p class="tracking-wide uppercase">{{ title }}</p>
</template>
